import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        const analysisId = JSON.parse(localStorage.getItem("oa_purchase_intent") || "null")?.analysis_id;
        const { data } = await api.post("/auth/session", { session_id: sessionId, analysis_id: analysisId });
        if (data.token) localStorage.setItem("oa_token", data.token);
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: data.user } });
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F9FAFB]">
      <p className="mono-label">Signing you in…</p>
    </div>
  );
}
